import React from "react";

const LogsBackup = () => {
    return (
        <div className="content">
            <div className="col-12">
                <div id="page-header">
                    <h1>Резервні копії логів</h1>
                </div>
                <form id="list_form" method="post">
                    <a className="check_all" href="#">
                        Виділити все
                    </a>
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th className="no-mobile"></th>
                                <th>Назва</th>
                                <th className="no-mobile">Розмір</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td className="check_area text-start fit no-mobile">
                                    <div className="custom-control custom-checkbox">
                                        <input
                                            type="checkbox"
                                            className="custom-control-input"
                                            id="check_u20"
                                            name="check[]"
                                            value="logs_2018_11_01_12_00_02.sql"
                                        />
                                        <label className="custom-control-label" for="check_u20">
                                            &nbsp;
                                        </label>
                                    </div>
                                </td>

                                <td>
                                    <a href="files/logs/logs_2018_11_01_12_00_02.sql">logs_2018_11_01_12_00_02.sql</a>
                                </td>
                                <td className="no-mobile">8.23 МБ</td>
                            </tr>
                            <tr>
                                <td className="check_area text-start fit no-mobile">
                                    <div className="custom-control custom-checkbox">
                                        <input
                                            type="checkbox"
                                            className="custom-control-input"
                                            id="check_u21"
                                            name="check[]"
                                            value="logs_2018_10_01_12_00_01.sql"
                                        />
                                        <label className="custom-control-label" for="check_u21">
                                            &nbsp;
                                        </label>
                                    </div>
                                </td>

                                <td>
                                    <a href="files/logs/logs_2018_10_01_12_00_01.sql">logs_2018_10_01_12_00_01.sql</a>
                                </td>
                                <td className="no-mobile">6.94 МБ</td>
                            </tr>
                            <tr>
                                <td className="check_area text-start fit no-mobile">
                                    <div className="custom-control custom-checkbox">
                                        <input
                                            type="checkbox"
                                            className="custom-control-input"
                                            id="check_u22"
                                            name="check[]"
                                            value="logs_2018_09_01_12_00_04.sql"
                                        />
                                        <label className="custom-control-label" for="check_u22">
                                            &nbsp;
                                        </label>
                                    </div>
                                </td>

                                <td>
                                    <a href="files/logs/logs_2018_09_01_12_00_04.sql">logs_2018_09_01_12_00_04.sql</a>
                                </td>
                                <td className="no-mobile">5.42 МБ</td>
                            </tr>
                            <tr>
                                <td className="check_area text-start fit no-mobile">
                                    <div className="custom-control custom-checkbox">
                                        <input
                                            type="checkbox"
                                            className="custom-control-input"
                                            id="check_u23"
                                            name="check[]"
                                            value="logs_2018_08_01_12_00_03.sql"
                                        />
                                        <label className="custom-control-label" for="check_u23">
                                            &nbsp;
                                        </label>
                                    </div>
                                </td>

                                <td>
                                    <a href="files/logs/logs_2018_08_01_12_00_03.sql">logs_2018_08_01_12_00_03.sql</a>
                                </td>
                                <td className="no-mobile">4.12 МБ</td>
                            </tr>
                            <tr>
                                <td className="check_area text-start fit no-mobile">
                                    <div className="custom-control custom-checkbox">
                                        <input
                                            type="checkbox"
                                            className="custom-control-input"
                                            id="check_u24"
                                            name="check[]"
                                            value="logs_2018_07_20_14_57_16.sql"
                                        />
                                        <label className="custom-control-label" for="check_u24">
                                            &nbsp;
                                        </label>
                                    </div>
                                </td>

                                <td>
                                    <a href="files/logs/logs_2018_07_20_14_57_16.sql">logs_2018_07_20_14_57_16.sql</a>
                                </td>
                                <td className="no-mobile">9.33 МБ</td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="d-flex">
                        <select name="action" className="form-select" style={{ width: "auto" }}>
                            <option value="delete">Видалити</option>{" "}
                        </select>
                        <input type="submit" className="btn btn-info mx-3" value="Зберегти" />
                    </div>
                </form>
            </div>
        </div>
    );
};

export default LogsBackup;
